import {
  ProjectExperiments,
  SessionExperiments,
  UserExperiments,
} from '../experiments';

export const sessionExperiments: Partial<SessionExperiments> = {
  'T110292-webapp-login-signup-whitelist': 'test',
  'T140960-webapp-login-signup': 'test',
};

export const userExperiments: Partial<UserExperiments> = {
  'FIN-1113-force-avs-2': 'control',
  'T104418-dashboard-give-get-banner-and-give-get-page': 'control',
  'T111865-logged-in-pjp-live-chat-just-enrollment': 'control',
  'T58186-giveget-delayed-payment-verify-v2': 'control',
  'T90189-image-thumbnail-service': 'control',
  'TNS-T124759-hireme-default-hourly': 'control',
  webapp_playground_test: 'control',
};
export const projectExperiments: Partial<ProjectExperiments> = {};

export const isWhitelistUser = false;

export const shouldEnrol = true;
